<template>
    <div class="post row">
        <div class="image" :class="smallViewPort ? 'small-view-image':'col-4'">
            <b-carousel style="box-shadow: 0px 0px 1px 1px #888888;" controls indicators fade background="#ababab" :interval="0" img-width="1024" img-height="150">
                <b-carousel-slide v-for="(uri, i) in post.imageURIs" :key="i+uri">
                    <div slot="img" :style="`background-image: url(${uri}); width: 100%; height: 150px; background-repeat: no-repeat; background-size: contain; background-color: rgba(0,0,0,0); background-position: center;`"></div>
                </b-carousel-slide>
            </b-carousel>
        </div>
        <div class="post-text-info text-left" :class="smallViewPort ? 'small-view-post':'col-8'">
            <router-link class="nav-link" :to="'/post/'+post._id">
                <div class="post-name font-weight-bold">
                    {{post.title}} <span v-if="post.status !== 'selling'" :class="{'text-info': post.status === 'sold', 'text-danger': post.status === 'canceled'}" style="text-transform: uppercase; font-weight: 100">[{{langPost[post.status][locale]}}]</span>
                </div>
                <div class="post-info text-muted">{{post.type[$store.state.locale]}} {{post.maker ? ' | '+post.maker[$store.state.locale] : ''}} {{post.subType ? ' | '+post.subType[$store.state.locale] : ''}} {{post.frameSize ? ' | '+post.frameSize[$store.state.locale] : ''}}</div>
                <div class="post-description" v-if="!smallViewPort">
                    {{post.description}}
                </div>
                <div v-if="post.status !== 'sold'">
                    <div class="post-old-price" v-if="post.oldPrice"><strike><small>€{{post.oldPrice}}</small></strike></div>
                    <div class="post-current-price font-weight-bold text-primary"><kbd>€{{post.currentPrice}}</kbd></div>
                </div>
                <div class="post-location-owner text-muted">
                    <small class="post-location">{{post.country}}</small>
                    <small> > </small>
                    <small class="post-location">{{post.province}}</small>
                    <small> > </small>
                    <small class="post-location">{{post.city}}</small>
                    <small> > </small>
                    <small class="post-owner font-weight-bold">{{post.user.name}} </small>
                    <small class="post-store-tag" v-if="post.user.role === 'store'">{{langPost.store[locale]}}</small>
                </div>
                <div class="text-muted" style="font-size: 0.8em"><font-awesome-icon :icon="'calendar-alt'" style="margin-right: 5px"/>{{` ${new Date(post.createdAt).getDate()}-${new Date(post.createdAt).getMonth()}-${new Date(post.createdAt).getFullYear()}`}}</div>
                <div style="border-top: 1px solid lightgray; width: 50%; margin-top: 2px"/>
                <div class="text-muted" style="font-size: 0.8em">
                    <strong>{{conditionText}}</strong>
                    <ConditionBar :value="post.condition"/>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import langPost from '@/store/lang/post';
import ConditionBar from '@/components/ConditionBar';

export default {
    name: "Post",
    components: {
        ConditionBar
    },
    props: {
        post: {
            type: Object,
            default() {
                return {
                    _id: "randomID",
                    name: `28" Tuntturi bike`,
                    frameSize: `28"`,
                    type: `Bike`,
                    maker: `Tuntturi`,
                    subType: `Sports`,
                    currentPrice: 100,
                    oldPrice: 150,
                    imageURIs: ["https://www.99bikes.com.au/media/catalog/product/cache/image/700x560/e9c3970ab036de70892d86c6d221abfe/u/p/uptown-blue_1.jpg", "http://www.wigglestatic.com/product-media/100375136/Brand-X-Road-Bike-Road-Bikes-Black-2017-BRNDXROADXL-0.jpg?w=960&h=430&a=7"],
                    gears: 3,
                    country: "Finland",
                    province: "Pohjois-pohjanmaa",
                    city: "Oulu",
                    user: {
                        name: "Prataksha Gurung",
                        role: "store"
                    }
                }
            }
        }
    },
    data() {
        return {
            langPost,
            smallViewPort: false
        }
    },
    computed: {
        ...mapState({
            locale: state => state.locale,
            filters: state => state.filters
        }), 
        conditionText() {
            let value = "";
            this.filters[this.locale].selectCondtionOptions.forEach(item => {
                if(item.value === this.post.condition) value = item.text;
            });
            return value;
        }
    },
    created() {
        this.SocialShareURL = window.location.href;
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize() {
            this.smallViewPort = window.innerWidth <= 600;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.post {
    padding: 5px;
    background-color: rgba(0,0,0,0.03);
    margin: 1em !important;

    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;

    .image {
        padding: 1em;
        position: relative;
    }

    .small-view-image {
        width: 100%;
    }

    .post-text-info {
        padding: 1em;
        padding-top: 0;

        .post-name {
            a {
                padding: 0;
            }
        }
        .post-store-tag {
            padding-left: 5px;
            padding-right: 5px;
            background: gray;
            border-radius: 2px;
            color: white;
        }
        .post-description {
            white-space: nowrap; 
            overflow: hidden;
            text-overflow: ellipsis;
            color: gray;
        }

        .post-location-owner {
            line-height: 1em;
        }
    }
}
</style>
